import { useContext, useMemo } from "react";
import { GlobalConfigContext } from "../../context/GlobalConfigContext";
import { DEFAULT_SURVEY_SOURCES, extractSurveyProviders } from "./surveyDrawerUtils";

export const useSurveyProviders = () => {
  const { programConfigurations } = useContext(GlobalConfigContext);
  return useMemo(() => {
    const providers = extractSurveyProviders(programConfigurations);
    return providers.length > 0 ? providers : DEFAULT_SURVEY_SOURCES;
  }, [programConfigurations]);
};
